<div class="layout">
  <div class="layout-topbar">
    <app-topbar [title]="title" [(profile)]="profile" (sidebarVisible)="sidebar($event)" [visible]="sidebarVisible()" (logout)="update()"></app-topbar>
  </div>
  <div class="layout-content">
    <div class="layout-sidebar" [ngClass]="!sidebarVisible()? 'inactive' : 'active'">
      <div>
        <app-sidebar [(visible)]="sidebarVisible" [(profile)]="profile" [(access)]="access"></app-sidebar>
      </div>
    </div>
    <div class="layout-main-container" [ngClass]="!sidebarVisible()? 'inactive' : 'active'">
      <div class="layout-main">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <div>
  </div>
  <div class="layout-footer">
    <!-- <app-footer></app-footer> -->
  </div>
</div>
